module.exports = __webpack_public_path__ + "img/2-1@2x.3171bf9b.png";